import React from "react";
import PartnerHome from "../partners/dashboard/PartnerHome";
import ClientDashboard from "../clients/dashboard/ClientDashboard";
import StaffDashboard from "../staff/StaffDashboard";

function InternalDashboard({ role }) {
  return <StaffDashboard role={role} />;
}

export default function Home({ role, partner }) {
  if (role === "superuser") return <StaffDashboard role="superuser" />;
  if (role === "partner" || partner) return <PartnerHome />;
  if (["hr", "developer", "designer", "marketing", "project_manager", "staff"].includes(role)) return <InternalDashboard role={role} />;
  return <ClientDashboard />;
}
